import React from 'react';
import Select from 'react-select';
import $ from 'jquery';

import { resolveDefaultSortOrder, sortOptions } from '@components/show_page/sections/view_options/helper';
import Tooltip from '@components/common/tooltip/main';

export default class DefaultSortForm extends React.Component {
  state = {
    selectedSortName: resolveDefaultSortOrder(this.props.sortName)
  };

  updateSortOrder(order) {
    this.setState({ selectedSortName: order });

    $.ajax({
      type: "PUT",
      url: `/api/v3/brandfolders/${this.props.brandfolderKey}`,
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ data: { attributes: { default_order_method: order } } }),
      beforeSend: (xhr) => {
        xhr.setRequestHeader('Authorization', `Bearer ${BF_Token}`);
      },
      success: () => {
        Notify.create({
          title: t("The default sort order has been updated for all users for this Brandfolder"),
          type: "success"
        });
      },
      error: () => {
        this.setState({ selectedSortName: this.props.sortName });
        Notify.create({
          title: t("An error occured and the default sort order was not changed. Please try again!"),
          type: "error"
        });
      }
    });
  }

  renderDropdown() {
    return (
      <Select
        name="download_as_options default-sort"
        value={this.state.selectedSortName}
        options={sortOptions()}
        clearable={false}
        searchable={false}
        onChange={(option) => this.updateSortOrder(option.value)}
      />
    );
  }

  render() {
    return (
      <div className="brandfolder-settings__default-sort">
        <h3>{t('Default Sort Option')}</h3>
        <Tooltip
          tooltipId="default-sort-info"
          tooltipContent={t("Set the default sort option for all users that visit this Brandfolder or any of its Collections.")}
        >
          <span className="bff-tool-tip" />
        </Tooltip>
        {this.renderDropdown()}
        <hr />
      </div>
    );
  }
}
